<template>
  <section>
    <div
      :class="
        narrow ? 'wh-full relative flex' : 'wh-full relative flex hide-viewer'
      "
      v-if="show"
      slot="webgl"
    >
      <!-- :style="'height:' + height + ';width:' + width + ';'" -->
      <div class="close" v-if="isAndroid">
        <img src="../../../static/images/gem/close.svg" @click="backMini" />
      </div>
      <WebGl
        class="webgl-container"
        v-if="ceramic.models.length"
        :url="ceramic.models[0].path_url"
        :styleObject="styleObject"
        :type="mini"
      ></WebGl>
      <div v-else class="orthographic">
        <img :src="ceramic.image_url" alt="" class="" />
      </div>
      <div class="gem-handle">
        <img
          src="../../../static/images/gem/gemDetaiIcon.svg"
          alt=""
          @click="showDetail"
        />
        <img
          src="../../../static/images/gem/gemFollow.svg"
          alt=""
          v-if="!follow"
          @click="followed"
        />
        <img
          src="../../../static/images/gem/gemFollowed.svg"
          alt=""
          v-else
          @click="followed"
        />
      </div>
      <div class="gem-detail" v-if="ceramic && isShow">
        <img
          src="../../../static/images/gem/gemClose.svg"
          alt=""
          @click="closeDetail"
          class="gem-close"
        />
        <div class="gem-content">
          <div class="gem-name">{{ ceramic.name }}</div>
          <div class="scroll-content">
            <!-- <div class="gem-audio">
              <div class="flex-row align-items-center">
                <img
                  src="../../../static/images/gem/gemVideo.svg"
                  alt=""
                  class="video-icon"
                />
                <div class="audio-date">00:56</div>
              </div>
            </div> -->
            <div class="gem-base-info">
              <div class="base-info">
                <div class="flex-row gem-flex-item justify-around">
                  <div class="flex-row row-item">
                    <div class="">烧造年代：</div>
                    <div>{{ ceramic.dynasty }}</div>
                  </div>
                  <div class="flex-row row-item">
                    <div>釉彩类别：</div>
                    <div>{{ ceramic.style }}</div>
                  </div>
                </div>
                <div class="flex-row gem-flex-item justify-around">
                  <div class="flex-row row-item">
                    <div class="">器型用途：</div>
                    <div>{{ ceramic.usage }}</div>
                  </div>
                  <div class="flex-row row-item">
                    <div>出土区域：</div>
                    <div>{{ ceramic.location }}</div>
                  </div>
                </div>
              </div>
            </div>
            <MarkdownViewer
              class="gem-description"
              :emptyText="'暂无描述'"
              :content="ceramic.description"
            ></MarkdownViewer>
            <!-- <div class="gem-description">{{ ceramic.description }}</div> -->
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import MarkdownViewer from '@/components/common/MarkdownViewer'
import { getCeramic, getSubcriber, getCeramicCollect } from '@/core/api'
import WebGl from './component/WebGl.vue'
import wx from 'weixin-js-sdk'
document.documentElement.style.fontSize =
  (document.documentElement.clientWidth / 750) * 100 + 'px'

export default {
  name: 'gem-detail',
  components: {
    WebGl,
    MarkdownViewer
  },
  data() {
    return {
      show: false,
      width: '',
      height: '',
      isAndroid: false,
      styleObject: {
        height: '',
        width: ''
      },
      mini: 'mini',
      narrow: true,
      ceramic: null,
      isShow: false,
      className: '',
      ceramics: [],
      follow: false,
      openid: '',
      originalId: '',
      name: ''
    }
  },
  async mounted() {
    this.openid = this.$route.query.openid
    this.originalId = this.$route.query.originalId
    this.name = this.$route.query.name
    window.document.title = this.$route.query.name
    this.getWindowContainer()
    // this.windowResize()
    await this.userInfo()
    this.getData()
    wx.miniProgram.getEnv(function(res) {
      // alert(res.miniprogram)
      console.log(res) // eslint-disable-line no-console
    })
    var u = navigator.userAgent
    this.isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 //android终端
    // var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
  },
  methods: {
    // windowResize() {
    //   window.onresize = () => {
    //     return (() => {
    //       this.getWindowContainer()
    //     })()
    //   }
    // },
    getWindowContainer() {
      let h =
        window.innerHeight ||
        document.documentElement.clientHeight ||
        document.body.clientHeight
      this.styleObject.height = h + 'px'
      this.height = h + 'px'
      this.styleObject.height = h + 'px'
      let width =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth
      this.width = width + 'px'
      this.styleObject.width = width + 'px'
    },
    backMini() {
      wx.miniProgram.navigateBack({
        url: '/pages/gem/index'
      })
    },
    showDetail() {
      this.isShow = true
    },
    async getData() {
      let res = await getCeramic(this.$route.params.id)
      this.ceramic = res.data

      if (res.status !== 200) {
        console.error('[minGem::getData] 数据返回错误', res) // eslint-disable-line no-console
      } else {
        this.ceramic = res.data
        if (this.$route.query.isLogin === 'true' && this.ceramics.length) {
          this.ceramics.forEach(element => {
            if (element.uuid === res.data.uuid) {
              this.follow = true
            }
          })
        }
        this.show = true
      }
    },
    closeDetail() {
      this.isShow = false
    },
    async userInfo() {
      let headers = {
        'WX-ORIGINAL-ID': this.originalId,
        'WX-OPEN-ID': this.openid
      }
      let res = await getSubcriber(headers)
      if (res.status !== 200) {
        console.error('[minGem::userInfo] 数据返回错误', res) // eslint-disable-line no-console
      } else {
        if (res.data.client && res.data.client.ceramics) {
          this.ceramics = res.data.client.ceramics
        }
      }
    },
    async followed() {
      if (this.$route.query.isLogin === 'false') {
        this.$swal({
          position: 'top-end',
          type: 'error',
          toast: true,
          text: '暂无收藏权限！登录后可继续！',
          showConfirmButton: false,
          customClass: 'swal-custom-css',
          timer: 3000
        })
        return false
      }
      let res = await getCeramicCollect(this.$route.params.id, {
        'WX-ORIGINAL-ID': this.originalId,
        'WX-OPEN-ID': this.openid
      })
      // console.log(res) // eslint-disable-line no-console
      if (res.status !== 200) {
        console.error('[minGem::followed] 数据返回错误', res) // eslint-disable-line no-console
      } else {
        this.follow = !this.follow
        wx.miniProgram.postMessage({
          data: {
            uuid: this.$route.params.id,
            favorite: this.follow
          }
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~pannellum/build/pannellum.css';
.wh-full {
  width: 100vw;
  height: 100vh;
}
section {
  overflow: hidden;
}
::v-deep  .app.mx-auto nav {
  display: none !important;
}
::v-deep  footer {
  display: none !important;
}
* {
  font-size: 0.21rem;
}
.close {
  width: 0.6rem;
  height: 0.6rem;
  position: fixed;
  top: 0.3rem;
  right: 0.3rem;
  z-index: 99;
}
.close img {
  width: 0.6rem;
  width: 0.6rem;
}
.gem-handle {
  width: 0.78rem;
  // height: 1.5rem;
  position: absolute;
  bottom: 0.5rem;
  right: 0.25rem;
  z-index: 22;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  img {
    margin-bottom: 0.3rem;
  }
}
.gem-detail {
  height: 45vh;
  width: 100%;
  border-top-left-radius: 0.2rem;
  border-top-right-radius: 0.2rem;
  background-color: rgba(255, 255, 255, 0.9);
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: 23;
}
.gem-content {
  padding: 0.7rem 0 0 0;
  height: 100%;
}
.scroll-content {
  height: 4.2rem;
  overflow: scroll;
  margin: 0.3rem 0;
  padding: 0 0.5rem;
}
.gem-name {
  padding: 0 0.5rem;
  font-size: 0.36rem;
  color: #222222;
}
.gem-audio {
  width: 100%;
}
.video-icon {
  width: 0.7rem;
  height: 0.7rem;
}
.audio-date {
  font-size: 0.28rem;
  color: #888888;
  margin-left: 0.2rem;
}
.gem-base-info {
  width: 100%;
  border: 0.02rem solid #ad9f82;
  padding: 0.05rem;
  box-sizing: border-box;
  border-radius: 0.1rem;
  min-height: 1.93rem;
  margin-top: 0.42rem;
}
.base-info {
  border: 0.02rem solid #ad9f82;
  border-radius: 0.1rem;
  min-height: 1.83rem;
  padding: 0.5rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-content: center;
}
.gem-flex-item {
  width: 100%;
  font-size: 28px;
  color: #555555;
}
.row-item {
  width: 50%;
}
.gem-description {
  width: 100%;
  font-size: 0.28rem;
  color: #555555;
  line-height: 0.52rem;
  margin-top: 0.2rem;
  margin-bottom: 0.8rem;
}
.gem-close {
  width: 0.26rem;
  height: 0.26rem;
  position: absolute;
  top: 0.25rem;
  right: 0.25rem;
  z-index: 25;
}
.mini-nav {
  width: 100%;
  background-color: #fff;
  position: fixed;
  z-index: 25;
  min-height: 66px;
  padding-top: 66px;
  width: 100%;
  z-index: 25;
}
.no-date {
  margin-top: 66px;
  color: red;
  text-align: center;
}
.gem-back {
  position: relative;
  bottom: 0.3rem;
  width: 0.21rem;
  height: 0.35rem;
  margin-left: 0.25rem;
}
.nav-gem-name {
  font-size: 0.36rem;
  color: #222222;
  margin-left: 2rem;
  position: relative;
  bottom: 0.3rem;
  max-width: 3.5rem;
  -o-text-overflow: ellipsis; /* Opera 9-10 */
  text-overflow: ellipsis;
  white-space: wrap;
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.webgl-container {
  width: 100%;
  height: 100%;
  /* margin-top: 86px; */
}
.orthographic {
  width: 100%;
  height: 100%;
  background-color: #000;
  text-align: center;
}
.orthographic img {
  width: 100%;
  height: 100%;
}
</style>
